import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

export default styled.div`
  padding: 83px 24px 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #1a5690;
  z-index: 1;

  &.menu-appear,
  &.menu-enter {
    opacity: 0;
  }

  &.menu-appear-active,
  &.menu-enter-active {
    opacity: 1;
    transition: opacity 100ms;
  }

  &.menu-exit {
    opacity: 1;
  }

  &.menu-exit-active {
    opacity: 0;
    transition: opacity 100ms;
  }

  @media screen and (min-width: ${DESKTOP}px) {
    padding: 156px 40px 80px;
  }
`;
